import { DestroyRef, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class DatePickerIntl extends MatDatepickerIntl {
    constructor(
        private readonly destroyRef: DestroyRef,
        private readonly translateService: TranslateService
    ) {
        super();
        this.monitorLanguageChanges();
    }

    /**
     * Starts monitoring language change. When the language changes, the texts are recomputed
     */
    monitorLanguageChanges(): void {
        this.translateService.onLangChange
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.recomputeTranslations();

                // Let the datepicker components know that the translations were recomputed
                this.changes.next();
            });
    }

    /**
     * Translates texts and labels within Angular Material Datepicker.
     */
    private recomputeTranslations(): void {
        this.calendarLabel = this.translateService.instant(
            'shared.matDatePicker.calendarLabel'
        );
        this.closeCalendarLabel = this.translateService.instant(
            'shared.matDatePicker.closeCalendarLabel'
        );
        this.nextMonthLabel = this.translateService.instant(
            'shared.matDatePicker.nextMonthLabel'
        );
        this.nextMultiYearLabel = this.translateService.instant(
            'shared.matDatePicker.nextMultiYearLabel'
        );
        this.nextYearLabel = this.translateService.instant(
            'shared.matDatePicker.nextYearLabel'
        );
        this.openCalendarLabel = this.translateService.instant(
            'shared.matDatePicker.openCalendarLabel'
        );
        this.prevMonthLabel = this.translateService.instant(
            'shared.matDatePicker.prevMonthLabel'
        );
        this.prevMultiYearLabel = this.translateService.instant(
            'shared.matDatePicker.prevMultiYearLabel'
        );
        this.prevYearLabel = this.translateService.instant(
            'shared.matDatePicker.prevYearLabel'
        );
        this.switchToMonthViewLabel = this.translateService.instant(
            'shared.matDatePicker.switchToMonthViewLabel'
        );
        this.switchToMultiYearViewLabel = this.translateService.instant(
            'shared.matDatePicker.switchToMultiYearViewLabel'
        );
        // Function 'formatYearRange' is not overriden here.

        this.formatYearRangeLabel = function (
            start: string,
            end: string
        ): string {
            return (
                this.translateService.instant('shared.matDatePicker.fromYear') +
                ' ' +
                start +
                ' ' +
                this.translateService.instant('shared.matDatePicker.toYear') +
                end
            );
        };
    }
}
